export class DeviceEvent {
    public date: Date;
    public channel: number;
    public message: string;
}
